import { api } from "@/lib/apiClient";

export type PartyOption = {
  id: string;
  name: string;
  type?: string | null;
  isCompany?: boolean;
  phone?: string | null;
  contactPerson?: string | null;
};

let cache: PartyOption[] = [];

export function listPartyOptions(): PartyOption[] {
  return cache;
}

export function listCompanyPartyOptions(): PartyOption[] {
  return cache.filter((p) => Boolean(p.isCompany));
}

export async function syncPartiesFromApi(params?: {
  isCompany?: boolean;
  type?: string;
}): Promise<PartyOption[]> {
  const query: Record<string, string | number | boolean> = { per_page: 500 };
  if (params?.isCompany) query.is_company = 1;
  if (params?.type) query.type = params.type;

  const response = await api.get("/api/v1/parties", { params: query });
  const body = response.data as { data?: unknown };
  const rows = Array.isArray(body?.data) ? body.data : [];
  const mapped = rows
    .map((row) => {
      if (!row || typeof row !== "object") return null;
      const r = row as Record<string, unknown>;
      const id = r.id;
      if (id == null) return null;
      return {
        id: String(id),
        name: String(r.name ?? `Party #${id}`),
        type: r.type == null ? null : String(r.type),
        isCompany: Boolean(r.is_company ?? r.isCompany),
        phone: r.phone == null ? null : String(r.phone),
        contactPerson: r.contact_person == null && r.contactPerson == null
          ? null
          : String(r.contact_person ?? r.contactPerson),
      } satisfies PartyOption;
    })
    .filter(Boolean) as PartyOption[];

  const byId = new Map(cache.map((p) => [p.id, p]));
  for (const p of mapped) {
    const existing = byId.get(p.id);
    byId.set(p.id, existing ? { ...existing, ...p } : p);
  }
  cache = [...byId.values()];
  return mapped;
}
